interface CategoryNode {
  id: string;
  name: string;
  parentId?: string | null;
}

/** id → "Pokemon › Raw" so same-named sub-categories stay distinguishable. */
export function categoryPathMap(categories: CategoryNode[]): Map<string, string> {
  const byId = new Map(categories.map((c) => [c.id, c]));
  const paths = new Map<string, string>();
  const resolve = (id: string, seen: Set<string>): string => {
    const cached = paths.get(id);
    if (cached) return cached;
    const node = byId.get(id);
    if (!node) return "";
    const parentPath =
      node.parentId && !seen.has(node.parentId) ? resolve(node.parentId, new Set(seen).add(id)) : "";
    const path = parentPath ? `${parentPath} › ${node.name}` : node.name;
    paths.set(id, path);
    return path;
  };
  for (const c of categories) resolve(c.id, new Set());
  return paths;
}

/** Select options labelled with the full path, sorted alphabetically by path. */
export function categoryPathOptions(categories: CategoryNode[]): { id: string; label: string }[] {
  const paths = categoryPathMap(categories);
  return categories
    .map((c) => ({ id: c.id, label: paths.get(c.id) ?? c.name }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
